<template>
  <transition name="banner-transition">
    <div class="banner-backdrop" v-if="shouldShowBanner">
      <div class="update-banner">
        <div class="banner-icon">
          <span>✨</span>
        </div>
        <div class="banner-content">
          <div class="banner-header">
            <h4>New Updates Available!.</h4>
            <p>
              We've made some exciting improvements to enhance your experience:
            </p>
          </div>
          <div class="banner-body">
            <h5>🚀 UI &amp; Feature Updates</h5>
            <ul>
              <li>
                <strong>New Sidebar:</strong> A fresh, more intuitive sidebar
                design.
              </li>
              <li>
                <strong>New Table UI:</strong> A new table UI for better
                organization.
              </li>
              <li>
                <strong>Receptionist Patient List:</strong> Now with a cleaner
                tab view.
              </li>
              <li>
                <strong>Doctor Patient List:</strong> Also updated with a new
                tab view for better organization.
              </li>
            </ul>
            <h5>🐛 Bug Fixes</h5>
            <ul>
              <li>Fixed an issue causing duplicate token numbers.</li>
            </ul>
          </div>
        </div>
        <button class="close-button" @click="closeBanner">×</button>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  methods: {
    ...mapActions("auth", ["setBannerVisibility"]),
    closeBanner() {
      localStorage.setItem("updateBannerClosed", "true");
      this.setBannerVisibility(false);
    }
  },
  computed: {
    ...mapGetters({
      showUpdateBannerFromStore: "auth/showUpdateBanner"
    }),
    shouldShowBanner() {
      const bannerClosed =
        localStorage.getItem("updateBannerClosed") === "true";
      const shouldShow = this.showUpdateBannerFromStore && !bannerClosed;
      console.log("Banner visibility check:", {
        showUpdateBannerFromStore: this.showUpdateBannerFromStore,
        bannerClosed,
        shouldShow
      });
      return shouldShow;
    }
  }
};
</script>

<style scoped>
/* Backdrop with blur effect */
.banner-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(27, 23, 48, 0.45);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 1498;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 80px;
}

/* Main banner container */
.update-banner {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  width: 90%;
  max-width: 700px;
  padding: 20px;
  background: var(--surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--line);
  box-shadow: var(--shadow-md);
  z-index: 1499;
  color: var(--text);
  position: relative;
}

/* Entrance and exit animations */
.banner-transition-enter-active,
.banner-transition-leave-active {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.banner-transition-enter,
.banner-transition-leave-to {
  opacity: 0;
}

.banner-transition-enter .update-banner,
.banner-transition-leave-to .update-banner {
  transform: translateY(-20px);
}

/* Icon on the left */
.banner-icon {
  font-size: 24px;
  padding: 10px;
  background: var(--accent-050);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Main content area */
.banner-content {
  flex: 1;
}

.banner-header h4 {
  font-size: var(--fs-h2);
  font-weight: 700;
  margin: 0 0 5px 0;
  color: var(--accent-700);
}

.banner-header p {
  margin: 0 0 15px 0;
  font-size: var(--fs-body);
  color: var(--muted);
}

.banner-body h5 {
  font-size: var(--fs-body);
  font-weight: 600;
  margin: 15px 0 8px 0;
  padding-bottom: 5px;
  border-bottom: 1px solid var(--line);
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text);
}

.banner-body ul {
  margin: 0;
  padding-left: 20px;
  list-style-type: disc;
}

.banner-body li {
  margin-bottom: 8px;
  font-size: var(--fs-sm);
  line-height: 1.5;
  color: var(--muted);
}

.banner-body li strong {
  color: var(--ink-900);
}

/* Close button */
.close-button {
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: var(--muted-soft);
  padding: 0;
  line-height: 1;
  transition: color var(--dur) var(--ease);
}

.close-button:hover {
  color: var(--text);
}
</style>
